module.exports = __webpack_public_path__ + "static/media/bank.27493535.png";